import Box from "@mui/material/Box";
import {NewLogoIconWithText} from "../NewHome/HomeIcons";
import {Button, DialogContent, Typography} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, {useContext, useEffect, useState} from "react";
import Dialog from "@mui/material/Dialog";
import {AuthContext} from "../../context/AuthContext";
import V2LoginForm from "./V2LoginForm";
import V2SignupMessage from "./V2SignupMessage";
import V2SignupForm from "./V2SignupForm";
import {useNavigate} from "react-router-dom";
import { trackLandingEvent } from "../../analytics/landingEvents";
import Hls from "hls.js";


const V2TopBarNavLink = ({label, href}) => {
    return (
        <Button
            component="a"
            href={href}
            variant="text"
            disableRipple
            sx={{
                minWidth: 'auto',
                padding: 0,
                textTransform: 'uppercase',
                fontFamily: '"Space Mono", monospace',
                fontWeight: 400,
                fontSize: '15px',
                lineHeight: '22px',
                letterSpacing: '-1px',
                color: 'black',
                opacity: 0.9,
                '&:hover': {
                    backgroundColor: 'transparent',
                    opacity: 0.7,
                },
            }}
        >
            {label}
        </Button>
    )
}

const V2SigninButton = ({onClick}) => {
    return (
        <Button
            variant="text"
            disableRipple
            sx={{
                backgroundColor: 'transparent',
                color: 'black',
                height: '36px',
                borderRadius: '999px',
                padding: '8px 14px',
                textTransform: 'uppercase',
                fontFamily: '"Space Mono", monospace',
                fontWeight: 400,
                fontSize: '15px',
                lineHeight: '22px',
                letterSpacing: '-1px',
                whiteSpace: 'nowrap',
                zIndex: 1,
                border: '1px solid transparent',
                '&:hover': {
                    backgroundColor: 'transparent',
                    borderColor: 'rgba(0,0,0,0.18)',
                    opacity: 0.75,
                },
            }}
            onClick={onClick}
        >
            Sign In
        </Button>
    )
}

const V2GetStartedButton = ({onClick}) => {
    return (
        <Button
            variant="contained"
            sx={{
                backgroundColor: 'black',
                color: 'white',
                height: '30px',
                borderRadius: '10px',
                padding: '13px 14px',
                textTransform: 'uppercase',
                fontFamily: '"Space Mono", monospace',
                fontWeight: 700,
                fontSize: '14px',
                lineHeight: '22px',
                letterSpacing: '-0.8px',
                boxShadow: '0px 1px 4px 0px rgba(0,0,0,0.25)',
                whiteSpace: 'nowrap',
                zIndex: 1,
                '&:hover': {
                    backgroundColor: '#333',
                },
            }}
            onClick={onClick}
        >
            Get Started
        </Button>
    )
}

const OrangeFloatingPlaybackIcon = () => {
    return (
        <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="94.9984" height="94.9984" rx="47.4992" fill="#FBEAD6"/>
            <path d="M36 36.0002H58" stroke="#ED6F39" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M39.668 30.5002H54.3346" stroke="#ED6F39" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M45.6434 48.9637L50.6246 51.9099C51.2552 52.282 51.2552 53.195 50.6246 53.5672L45.6434 56.5134C45.0017 56.8929 44.1914 56.4309 44.1914 55.6847V49.7942C44.1896 49.0462 45.0017 48.5842 45.6434 48.9637V48.9637Z" stroke="#ED6F39" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M59.8333 63.5H34.1667C32.1408 63.5 30.5 61.8592 30.5 59.8333V45.1667C30.5 43.1408 32.1408 41.5 34.1667 41.5H59.8333C61.8592 41.5 63.5 43.1408 63.5 45.1667V59.8333C63.5 61.8592 61.8592 63.5 59.8333 63.5Z" stroke="#ED6F39" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const YellowFloatingCamIcon = () => {
    return (
        <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="83.4732" height="83.4732" rx="41.7366" fill="#FDF4CF"/>
            <path d="M48.6641 39.1541L54.4561 35.5839C54.9703 35.2669 55.6157 35.2529 56.1432 35.5474C56.6706 35.8418 56.9974 36.3986 56.9974 37.0026V48.664C56.9974 49.268 56.6706 49.8248 56.1432 50.1192C55.6158 50.4137 54.9704 50.3997 54.4562 50.0828L48.6641 46.5124" stroke="#F4B940" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="27" y="32" width="21.6667" height="21.6667" rx="5" stroke="#F4B940" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const RedTimelineCutIcon = () => {
    return (
        <svg width="99" height="99" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="98.6421" height="98.6421" rx="49.321" fill="#FCECE4"/>
            <path d="M60 43.4455H67.3333" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M60 54.5002H67.3333" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M48.9987 52.6665V56.3332" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M48.9987 42.3262V45.9928" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M38.0013 54.5544H30.668" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M38.0013 43.5002H30.668" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M41.668 63.6668H34.793C33.6989 63.6671 32.6495 63.2325 31.8759 62.4589C31.1023 61.6853 30.6677 60.6359 30.668 59.5418V38.4585C30.6677 37.3644 31.1023 36.3151 31.8759 35.5414C32.6495 34.7678 33.6989 34.3333 34.793 34.3335H41.668" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M56.332 34.3335H63.207C64.3011 34.3333 65.3505 34.7678 66.1241 35.5414C66.8977 36.3151 67.3323 37.3644 67.332 38.4585V59.5418C67.3323 60.6359 66.8977 61.6853 66.1241 62.4589C65.3505 63.2325 64.3011 63.6671 63.207 63.6668H56.332" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M59.9987 34.3335V63.6668" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M38.2214 34.3335V63.6668" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M51.7421 67.3332H46.25C45.9218 67.3361 45.6174 67.1619 45.4535 66.8775C45.2897 66.593 45.2917 66.2424 45.4588 65.9598L48.2048 61.3633C48.3721 61.086 48.6722 60.9165 48.996 60.9165C49.3199 60.9165 49.62 61.086 49.7873 61.3633L52.5333 65.9598C52.7004 66.2424 52.7024 66.593 52.5386 66.8775C52.3747 67.1619 52.0703 67.3361 51.7421 67.3332V67.3332Z" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M46.25 30.6665H51.7421C52.0703 30.6637 52.3747 30.8378 52.5386 31.1222C52.7024 31.4067 52.7004 31.7573 52.5333 32.0399L49.7873 36.6364C49.62 36.9137 49.3199 37.0832 48.996 37.0832C48.6722 37.0832 48.3721 36.9137 48.2048 36.6364L45.4588 32.0399C45.2917 31.7573 45.2897 31.4067 45.4535 31.1222C45.6174 30.8378 45.9218 30.6637 46.25 30.6665Z" stroke="#EB4241" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const LightBlueFloatingIcon = () => {
    return (
        <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="81.2802" height="81.2802" rx="40.6401" fill="#E5F8FE"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M26.75 42.5833V31.5C26.75 28.8766 28.8766 26.75 31.5 26.75H50.5C53.1234 26.75 55.25 28.8766 55.25 31.5V42.5833C55.25 45.2067 53.1234 47.3333 50.5 47.3333H31.5C28.8766 47.3333 26.75 45.2067 26.75 42.5833Z" stroke="#4A9EE4" strokeWidth="2.375" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M38.0249 39.9695V34.1141C38.025 33.7463 38.2213 33.4065 38.5399 33.2227C38.8585 33.0389 39.2509 33.0391 39.5693 33.2231L44.6357 36.1508C44.9539 36.3347 45.1499 36.6743 45.1499 37.0418C45.1499 37.4093 44.9539 37.7489 44.6357 37.9327L39.5694 40.8605C39.2509 41.0445 38.8585 41.0447 38.5399 40.8609C38.2213 40.6771 38.025 40.3373 38.0249 39.9695V39.9695Z" stroke="#4A9EE4" strokeWidth="2.375" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M53.6668 53.6667H37.8335" stroke="#4A9EE4" strokeWidth="2.375" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M28.3335 53.6667H33.0835" stroke="#4A9EE4" strokeWidth="2.375" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M33.0832 55.2502V52.0835" stroke="#4A9EE4" strokeWidth="2.375" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    )
}

const PurpleFloatingFilmIcon = () => {
    return (
        <svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="79" height="79" rx="39.5" fill="#F4E6FD"/>
            <path d="M32.5 26.3594V53.3594" stroke="#9A64F6" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M47.5 53.3594V26.3594" stroke="#9A64F6" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M50.5 53.3594H29.5C27.8425 53.3594 26.5 52.0169 26.5 50.3594V29.3594C26.5 27.7019 27.8425 26.3594 29.5 26.3594H50.5C52.1575 26.3594 53.5 27.7019 53.5 29.3594V50.3594C53.5 52.0169 52.1575 53.3594 50.5 53.3594Z" stroke="#9A64F6" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M32.5 32.3594H26.5" stroke="#9A64F6" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M32.5 47.3594H26.5" stroke="#9A64F6" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M47.5 47.3594H53.5" stroke="#9A64F6" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M47.5 32.3594H53.5" stroke="#9A64F6" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M53.5 39.8594H26.5" stroke="#9A64F6" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

const CyanFloatingIcon = () => {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="75.1664" height="75.1664" rx="37.5832" fill="#E3FBFA"/>
            <path d="M47.5459 28.4541C52.818 33.7261 52.818 42.2739 47.5459 47.5459C42.2738 52.818 33.7261 52.818 28.4541 47.5459C23.182 42.2738 23.182 33.7261 28.4541 28.4541C33.7261 23.182 42.2739 23.182 47.5459 28.4541" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M38 51.5H51.5" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M38 45.5V47" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M38 29V30.5" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M30.5 38H29" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M47 38H45.5" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M43.3109 43.31L44.3609 44.36" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M31.6391 31.64L32.6891 32.69" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M32.6891 43.31L31.6391 44.36" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M44.3609 31.64L43.3109 32.69" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M40.1213 35.8787C41.2929 37.0503 41.2929 38.9498 40.1213 40.1213C38.9498 41.2929 37.0503 41.2929 35.8787 40.1213C34.7071 38.9498 34.7071 37.0503 35.8787 35.8787C37.0503 34.7071 38.9498 34.7071 40.1213 35.8787" stroke="#57BEB9" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

// Shared registry for coordinating video playback - only one video plays at a time
const videoRegistry = {
    videos: new Map<string, { 
        play: () => void; 
        pause: () => void; 
        getViewportCenter: () => number;
    }>(),
    currentlyPlaying: null as string | null,
    hoveredVideo: null as string | null,
    
    register(id: string, controls: { play: () => void; pause: () => void; getViewportCenter: () => number }) {
        this.videos.set(id, controls);
    },
    
    unregister(id: string) {
        this.videos.delete(id);
        if (this.currentlyPlaying === id) this.currentlyPlaying = null;
        if (this.hoveredVideo === id) this.hoveredVideo = null;
    },
    
    setHovered(id: string | null) {
        this.hoveredVideo = id;
        this.updatePlayback();
    },
    
    updatePlayback() {
        // If a video is hovered, play that one
        if (this.hoveredVideo && this.videos.has(this.hoveredVideo)) {
            if (this.currentlyPlaying !== this.hoveredVideo) {
                // Pause current
                if (this.currentlyPlaying && this.videos.has(this.currentlyPlaying)) {
                    this.videos.get(this.currentlyPlaying)!.pause();
                }
                // Play hovered
                this.videos.get(this.hoveredVideo)!.play();
                this.currentlyPlaying = this.hoveredVideo;
            }
            return;
        }
        
        // Otherwise, find the video closest to viewport center and play it
        let bestId: string | null = null;
        let bestDistance = Infinity;
        
        this.videos.forEach((controls, id) => {
            const distance = controls.getViewportCenter();
            if (distance < bestDistance) {
                bestDistance = distance;
                bestId = id;
            }
        });
        
        // Only play if video is reasonably visible (within 60% of viewport height from center)
        if (bestId && bestDistance < window.innerHeight * 0.6) {
            if (this.currentlyPlaying !== bestId) {
                // Pause current
                if (this.currentlyPlaying && this.videos.has(this.currentlyPlaying)) {
                    this.videos.get(this.currentlyPlaying)!.pause();
                }
                // Play best
                this.videos.get(bestId)!.play();
                this.currentlyPlaying = bestId;
            }
        } else {
            // Pause all if nothing is close enough
            if (this.currentlyPlaying && this.videos.has(this.currentlyPlaying)) {
                this.videos.get(this.currentlyPlaying)!.pause();
            }
            this.currentlyPlaying = null;
        }
    }
};

// Global scroll listener for viewport-based playback
let scrollListenerAttached = false;
const attachScrollListener = () => {
    if (scrollListenerAttached) return;
    scrollListenerAttached = true;
    
    let ticking = false;
    const onScroll = () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                videoRegistry.updatePlayback();
                ticking = false;
            });
            ticking = true;
        }
    };
    
    window.addEventListener('scroll', onScroll, { passive: true });
};

// Video placeholder component - plays m3u8/video silently with delayed loop
// Only one video plays at a time: hovered video takes priority, otherwise most central
const VideoPlaceholder = ({ 
    aspectRatio = '16/10',
    playbackId,  // Mux playback ID (the part after stream.mux.com/)
    loopDelay = 2000,  // Delay in ms before restarting video
    sx,
}: { 
    aspectRatio?: string;
    playbackId?: string;
    loopDelay?: number;
    sx?: any;
}) => {
    const videoRef = React.useRef<HTMLVideoElement>(null);
    const containerRef = React.useRef<HTMLDivElement>(null);
    const hlsRef = React.useRef<any>(null);
    const [isInitialized, setIsInitialized] = React.useState(false);
    const instanceId = React.useRef(`video-${playbackId}-${Math.random().toString(36).substr(2, 9)}`);

    const videoUrl = playbackId ? `https://stream.mux.com/${playbackId}.m3u8` : '';
    const posterUrl = playbackId
        ? `https://image.mux.com/${playbackId}/thumbnail.png?time=1&width=1280&height=720&fit_mode=preserve`
        : '';

    // Initialize HLS when component mounts
    React.useEffect(() => {
        const video = videoRef.current;
        if (!video || !videoUrl || isInitialized) return;

            const initVideo = async () => {
            // Check if HLS is supported natively (Safari)
            if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = videoUrl;
            } else {
                // Use hls.js for other browsers
                if (Hls.isSupported()) {
                    const hls = new Hls();
                    hlsRef.current = hls;
                    hls.loadSource(videoUrl);
                    hls.attachMedia(video);
                }
            }
            setIsInitialized(true);
        };

        initVideo();

        return () => {
            if (hlsRef.current) {
                hlsRef.current.destroy();
                hlsRef.current = null;
            }
        };
    }, [videoUrl, isInitialized]);

    // Register with video registry for coordinated playback
    React.useEffect(() => {
        if (!isInitialized || !playbackId) return;
        
        const video = videoRef.current;
        const container = containerRef.current;
        if (!video || !container) return;

        const id = instanceId.current;
        
        videoRegistry.register(id, {
            play: () => {
                video.play().catch(() => {});
            },
            pause: () => {
                video.pause();
            },
            getViewportCenter: () => {
                const rect = container.getBoundingClientRect();
                const elementCenter = rect.top + rect.height / 2;
                const viewportCenter = window.innerHeight / 2;
                return Math.abs(elementCenter - viewportCenter);
            }
        });

        // Attach scroll listener and trigger initial check
        attachScrollListener();
        videoRegistry.updatePlayback();

        return () => {
            videoRegistry.unregister(id);
        };
    }, [isInitialized, playbackId]);

    // Handle video end - pause, then restart after delay
    React.useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleEnded = () => {
            setTimeout(() => {
                video.currentTime = 0;
                // Only auto-replay if this video is still the active one
                if (videoRegistry.currentlyPlaying === instanceId.current) {
                    video.play().catch(() => {});
                }
            }, loopDelay);
        };

        video.addEventListener('ended', handleEnded);
        return () => video.removeEventListener('ended', handleEnded);
    }, [loopDelay]);

    // Hover handlers
    const handleMouseEnter = () => {
        if (playbackId) {
            videoRegistry.setHovered(instanceId.current);
        }
    };

    const handleMouseLeave = () => {
        videoRegistry.setHovered(null);
    };

    return (
        <Box
            ref={containerRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            sx={{
                width: '100%',
                aspectRatio,
                backgroundColor: '#F5F5F4',
                borderRadius: '12px',
                border: '1px solid #E8E8E8',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                ...(sx || {}),
            }}
        >
            {playbackId ? (
                <video
                    ref={videoRef}
                    muted
                    playsInline
                    poster={posterUrl}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
            ) : (
                <Typography
                    sx={{
                        fontFamily: '"Inter", sans-serif',
                        fontSize: '14px',
                        color: '#9CA3AF',
                        textAlign: 'center',
                        px: 2,
                    }}
                >
                    Video placeholder
                </Typography>
            )}
        </Box>
    );
};

// Video playback IDs for feature sections (Mux)
// Replace these with your actual Mux playback IDs
const RECORDING_VIDEO_ID = '33g49nditIMWkzyLAUSx9KWhTyKpro5j62hNpYys3BI';
const EDITING_VIDEO_ID = 'vylFIDX57LThV7yh2dB5ZqGID1x2aWpSYwUL9Bf7WHI';
const EXPORT_VIDEO_ID = 'f6gBA8c84bbvLhjd7d4Gefx7ZTfhi4qjf9GR9PpIYfA';

const HeroSection = ({isMobile, handleLoginFormOpen, handleSignupFormOpen}) => {

    const [showPrivateBetaText, setShowPrivateBetaText] = useState(false);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '16px', md: '20px' },
                alignItems: 'center',
                position: 'relative',
                width: '100%',
                height: '100%',
                minHeight: { xs: '280px', md: '400px' },
            }}
        >
            {/* Floating Icons - Left Side */}
            <Box
                sx={{
                    position: 'absolute',
                    left: '5%',
                    top: '-20px',
                    display: isMobile ? 'none' : 'block',
                }}
            >
                <YellowFloatingCamIcon />
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    left: '12%',
                    top: '120px',
                    display: isMobile ? 'none' : 'block',
                }}
            >
                <OrangeFloatingPlaybackIcon />
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    left: '3%',
                    top: '260px',
                    display: isMobile ? 'none' : 'block',
                }}
            >
                <RedTimelineCutIcon />
            </Box>

            {/* Floating Icons - Right Side */}
            <Box
                sx={{
                    position: 'absolute',
                    right: '3%',
                    top: '-30px',
                    display: isMobile ? 'none' : 'block',
                }}
            >
                <LightBlueFloatingIcon />
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    right: '10%',
                    top: '100px',
                    display: isMobile ? 'none' : 'block',
                }}
            >
                <PurpleFloatingFilmIcon />
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    right: '5%',
                    top: '240px',
                    display: isMobile ? 'none' : 'block',
                }}
            >
                <CyanFloatingIcon />
            </Box>

            {/* Text Content */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: '10px', sm: '12px' },
                    alignItems: 'center',
                    textAlign: 'center',
                    width: '100%',
                    zIndex: 1,
                    px: { xs: 2, sm: 0 },
                }}
            >
                {/* Label and Headline */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '2px',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    {/* Label */}
                    {/*<Typography*/}
                    {/*    sx={{*/}
                    {/*        fontFamily: '"Space Mono", monospace',*/}
                    {/*        fontSize: { xs: '13px', sm: '15px' },*/}
                    {/*        lineHeight: { xs: '20px', sm: '24px' },*/}
                    {/*        letterSpacing: '-0.8px',*/}
                    {/*        textTransform: 'uppercase',*/}
                    {/*        opacity: 0.7,*/}
                    {/*        color: 'black',*/}
                    {/*        whiteSpace: 'pre',*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Recording & editing workspace*/}
                    {/*</Typography>*/}

                    {/* Headline */}
                    <Typography
                        sx={{
                            fontFamily: '"Hedvig Letters Serif", serif',
                            fontSize: { xs: '38px', sm: '60px' },
                            lineHeight: { xs: '44px', sm: '67.343px' },
                            letterSpacing: { xs: '-1.2px', sm: '-2.5159px' },
                            color: 'black',
                            maxWidth: { xs: '520px', sm: '900px' },
                            width: '100%',
                        }}
                    >
                        A better way to record and edit.
                    </Typography>
                </Box>

                {/* Description */}
                <Typography
                    sx={{
                        fontFamily: '"Inter", sans-serif',
                        fontWeight: 500,
                        fontSize: { xs: '16px', sm: '18px' },
                        lineHeight: { xs: '24px', sm: '27px' },
                        letterSpacing: '-0.5px',
                        opacity: 0.65,
                        color: 'black',
                        width: { xs: 'min(520px, 100%)', sm: '502px' },
                        maxWidth: '100%',
                    }}
                >
                    Studio-quality recording and stable, fast editing for spoken-word content.
                </Typography>
            </Box>


            {/* Button */}
            <Button
                variant="contained"
                onMouseEnter={() => setShowPrivateBetaText(true)}
                onMouseLeave={() => setShowPrivateBetaText(false)}
                sx={{
                    backgroundColor: 'black',
                    color: 'white',
                    height: '36px',
                    borderRadius: '10px',
                    padding: '13px 14px',
                    textTransform: 'uppercase',
                    fontFamily: '"Space Mono", monospace',
                    fontWeight: 700,
                    fontSize: '15px',
                    minWidth: "150px",
                    lineHeight: '24px',
                    letterSpacing: '-0.8px',
                    boxShadow: '0px 1px 4px 0px rgba(0,0,0,0.25)',
                    whiteSpace: 'nowrap',
                    zIndex: 1,
                    '&:hover': {
                        backgroundColor: '#333',
                    },
                }}
                onClick={(e) => {
                    handleSignupFormOpen(e);
                    trackLandingEvent("landing_cta_click_hero_get_started");
                }}
            >
                Get Started
            </Button>
            <Box sx={{marginTop: '-10px', display: showPrivateBetaText ? 'block' : 'none'}}>
                <Typography
                    sx={{
                        fontFamily: '"Space Mono", monospace',
                        fontSize: '13px',
                        lineHeight: '20px',
                        letterSpacing: '-0.8px',
                        textTransform: 'uppercase',
                        opacity: 0.7,
                        color: 'black',
                        whiteSpace: 'pre',
                    }}
                >
                    Limited release for invited users only.
                </Typography>
            </Box>
        </Box>
    );
}

const HowItWorksRecordingIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="6" width="18" height="12" rx="3" stroke="currentColor" strokeWidth="1.5" />
        <path d="M10.25 9.5V14.5L14.25 12L10.25 9.5Z" fill="currentColor" />
    </svg>
);

const HowItWorksEditingIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path
            d="M4 20H6.5L18.2 8.3C18.6 7.9 18.6 7.3 18.2 6.9L17.1 5.8C16.7 5.4 16.1 5.4 15.7 5.8L4 17.5V20Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path d="M13.8 7.7L16.3 10.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const HowItWorksPublishingIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path d="M12 3V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M8 7L12 3L16 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M4 13.5V20C4 20.55 4.45 21 5 21H19C19.55 21 20 20.55 20 20V13.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

const HowItWorksCard = ({
    icon,
    title,
    description,
    descriptionMaxWidth,
    playbackId,
    minHeight,
}: {
    icon: React.ReactNode;
    title: string;
    description: string;
    descriptionMaxWidth?: any;
    playbackId: string;
    minHeight: any;
}) => (
    <Box
        sx={{
            width: '100%',
            minHeight,
            backgroundColor: '#F6F5F4',
            borderRadius: { xs: '20px', md: '28px' },
            border: '1px solid rgba(0,0,0,0.03)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
        }}
    >
        <Box
            sx={{
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'rgba(0,0,0,0.85)' }}>
                <Box sx={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {icon}
                </Box>
                <Typography
                    sx={{
                        fontFamily: '"Space Mono", monospace',
                        fontWeight: 700,
                        fontSize: '15px',
                        lineHeight: '24px',
                        letterSpacing: '-0.8px',
                        textTransform: 'uppercase',
                        color: 'black',
                    }}
                >
                    {title}
                </Typography>
            </Box>
            <Typography
                sx={{
                    fontFamily: '"Inter", sans-serif',
                    fontSize: { xs: '16px', md: '18px' },
                    lineHeight: { xs: '22px', md: '26px' },
                    letterSpacing: '-0.5px',
                    color: 'black',
                    opacity: 0.7,
                    maxWidth: descriptionMaxWidth || { xs: '280px', md: '336px' },
                }}
            >
                {description}
            </Typography>
        </Box>

        <Box sx={{ marginTop: 'auto', px: 3, pb: 3 }}>
            <Box
                sx={{
                    backgroundColor: 'white',
                    borderRadius: { xs: '18px', md: '20px' },
                    boxShadow: '0px 4px 44px rgba(0,0,0,0.03)',
                    overflow: 'hidden',
                }}
            >
                <VideoPlaceholder
                    aspectRatio="16/10"
                    playbackId={playbackId}
                    sx={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        borderRadius: 0,
                    }}
                />
            </Box>
        </Box>
    </Box>
);

// Section 1: How it works
const HowItWorksSection = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    mb: { xs: '28px', md: '40px' },
                }}
            >
                <Typography
                    sx={{
                        fontFamily: '"Hedvig Letters Serif", serif',
                        fontSize: { xs: '28px', md: '54px' },
                        lineHeight: { xs: '30px', md: '60px' },
                        letterSpacing: { xs: '-1.5px', md: '-2.5px' },
                        color: 'black',
                        mb: { xs: 2, md: 2.5 },
                        maxWidth: { xs: '277px', md: 'none' },
                    }}
                >
                    From recording to finished content
                </Typography>
                <Typography
                    sx={{
                        fontFamily: '"Inter", sans-serif',
                        fontWeight: 500,
                        fontSize: { xs: '16px', md: '18px' },
                        lineHeight: { xs: '22px', md: '27px' },
                        letterSpacing: '-0.5px',
                        color: 'black',
                        opacity: 0.7,
                        maxWidth: { xs: '327px', md: '502px' },
                    }}
                >
                    All in one place, without switching tools.
                </Typography>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: '16px', md: '20px' },
                    maxWidth: { xs: '343px', md: '712px', lg: '822px' },
                    mx: 'auto',
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: '16px', md: '20px' } }}>
                    <HowItWorksCard
                        icon={<HowItWorksRecordingIcon />}
                        title="Recording"
                        description="Record solo or with others. High-quality audio & video. Reliable recordings with recovery and backups."
                        descriptionMaxWidth={{ xs: '280px', md: '298px', lg: '336px' }}
                        playbackId={RECORDING_VIDEO_ID}
                        minHeight={{ xs: '395px', md: '480px', lg: '445px' }}
                    />
                    <HowItWorksCard
                        icon={<HowItWorksEditingIcon />}
                        title="Editing"
                        description="Edit by transcript or timeline. Clean up audio automatically. Arrange layouts, scenes, captions."
                        descriptionMaxWidth={{ xs: '280px', md: '289px', lg: '336px' }}
                        playbackId={EDITING_VIDEO_ID}
                        minHeight={{ xs: '395px', md: '480px', lg: '445px' }}
                    />
                </Box>
                <HowItWorksCard
                    icon={<HowItWorksPublishingIcon />}
                    title="Publishing"
                    description="Export clean audio and video at up to 4K resolution. Locally or to a publish link to share and collaborate."
                    descriptionMaxWidth={{ xs: '280px', md: '336px', lg: '380px' }}
                    playbackId={EXPORT_VIDEO_ID}
                    minHeight={{ xs: '395px', md: '520px', lg: '518px' }}
                />
            </Box>
        </Box>
    );
};

const FeaturesTab = ({
    icon,
    label,
    isSelected,
    onClick,
}: {
    icon: React.ReactNode;
    label: string;
    isSelected: boolean;
    onClick: () => void;
}) => (
    <Button
        variant="text"
        disableRipple
        onClick={onClick}
        sx={{
            minWidth: 'max-content',
            padding: { xs: '8px 10px', md: '10px 12px' },
            borderRadius: '12px 12px 0 0',
            textTransform: 'none',
            borderBottom: isSelected ? '2px solid rgba(0,0,0,0.9)' : '2px solid transparent',
            backgroundColor: isSelected ? 'rgba(0,0,0,0.03)' : 'transparent',
            '&:hover': {
                backgroundColor: isSelected ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.02)',
                borderBottomColor: isSelected ? 'rgba(0,0,0,0.9)' : 'rgba(0,0,0,0.15)',
            },
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 1.25 }, color: isSelected ? 'black' : 'rgba(0,0,0,0.65)' }}>
            <Box
                sx={{
                    width: { xs: '18px', md: '28px' },
                    height: { xs: '18px', md: '28px' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& svg': {
                        width: '100%',
                        height: '100%',
                    },
                }}
            >
                {icon}
            </Box>
            <Box
                component="span"
                sx={{
                    fontFamily: '"Space Mono", monospace',
                    fontWeight: 700,
                    fontSize: { xs: '12px', md: '15px' },
                    lineHeight: 1,
                    letterSpacing: '-0.8px',
                    textTransform: 'uppercase',
                    whiteSpace: 'nowrap',
                }}
            >
                {label}
            </Box>
        </Box>
    </Button>
);

// Section 2: Features (tabbed)
const FeaturesSection = () => {
    const [activeTab, setActiveTab] = useState<'create' | 'edit' | 'polish' | 'publish'>('create');

    const tabs = {
        create: {
            label: "Create",
            icon: <HowItWorksRecordingIcon />,
            iconColor: "#ED6F39",
            screenshotSrc: "/assets/screenshots/recording-screenshot.png",
            heading: "Capture clean takes",
            bullets: [
                "Record solo or with others",
                "High-quality audio & video",
                "Reliable recordings with recovery and backups",
            ],
        },
        edit: {
            label: "Edit",
            icon: <HowItWorksEditingIcon />,
            iconColor: "#9A64F6",
            screenshotSrc: "/assets/screenshots/editor-page.png",
            heading: "Edit with precision",
            bullets: [
                "Edit by transcript or timeline",
                "Arrange layouts, scenes, captions",
                "Tighten pacing without the hassle",
            ],
        },
        polish: {
            label: "Polish",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M12 2.5L13.6 7.2L18.3 8.8L13.6 10.4L12 15.1L10.4 10.4L5.7 8.8L10.4 7.2L12 2.5Z"
                        fill="currentColor"
                    />
                    <path
                        d="M5.5 14.5L6.3 16.9L8.7 17.7L6.3 18.5L5.5 20.9L4.7 18.5L2.3 17.7L4.7 16.9L5.5 14.5Z"
                        fill="currentColor"
                        opacity="0.9"
                    />
                </svg>
            ),
            iconColor: "#F4B940",
            screenshotSrc: "/assets/screenshots/app-screenshot.png",
            heading: "Clean up audio",
            bullets: [
                "Remove long pauses quickly",
                "Improve clarity and balance",
                "Keep your mix consistent",
            ],
        },
        publish: {
            label: "Publish",
            icon: <HowItWorksPublishingIcon />,
            iconColor: "#57BEB9",
            screenshotSrc: "/assets/screenshots/home-dashboard.png",
            heading: "Export & share",
            bullets: [
                "Export clean audio and video",
                "Up to 4K resolution",
                "Share with a link or download",
            ],
        },
    };

    const activeTabConfig = tabs[activeTab];

    return (
        <Box sx={{ width: '100%', alignItems: 'center', }}>
            <Typography
                sx={{
                    fontFamily: '"Hedvig Letters Serif", serif',
                    fontSize: { xs: '28px', md: '48px' },
                    lineHeight: { xs: '34px', md: '54px' },
                    letterSpacing: { xs: '-1.2px', md: '-2.0px' },
                    color: 'black',
                    mb: { xs: 2, md: 2.5 },
                    maxWidth: { xs: '343px', md: '900px' },
                    mx: 'auto',
                    textAlign: 'center',
                }}
            >
                A workspace for your content
            </Typography>
            <Typography
                sx={{
                    fontFamily: '"Inter", sans-serif',
                    fontWeight: 500,
                    fontSize: { xs: '16px', md: '18px' },
                    lineHeight: { xs: '22px', md: '27px' },
                    letterSpacing: '-0.5px',
                    color: 'black',
                    opacity: 0.7,
                    maxWidth: { xs: '327px', md: '502px' },
                    mx: 'auto',
                    textAlign: 'center',
                    mb: { xs: 2, md: 4 },
                }}
            >
                Designed for spoken-word audio and video.
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: { xs: '8px', md: '10px' },
                    flexWrap: 'wrap',
                    mb: { xs: 3, md: 4 },
                }}
            >
                {Object.keys(tabs).map((key) => {
                    const tabKey = key as keyof typeof tabs;
                    const tab = tabs[tabKey];
                    const isSelected = activeTab === tabKey;

                    return (
                        <Button
                            key={tabKey}
                            variant="text"
                            disableRipple
                            onClick={() => setActiveTab(tabKey)}
                            sx={{
                                width: { xs: '92px', md: '136px' },
                                padding: { xs: '6px 10px', md: '9px 12px' },
                                borderRadius: '10px',
                                textTransform: 'none',
                                justifyContent: 'center',
                                backgroundColor: isSelected ? '#F6F5F4' : 'transparent',
                                '&:hover': {
                                    backgroundColor: '#F6F5F4',
                                },
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '4px', md: '8px' } }}>
                                <Box
                                    sx={{
                                        width: { xs: '18px', md: '28px' },
                                        height: { xs: '18px', md: '28px' },
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: tab.iconColor,
                                        '& svg': { width: '100%', height: '100%' },
                                    }}
                                >
                                    {tab.icon}
                                </Box>
                                <Box
                                    component="span"
                                    sx={{
                                        fontFamily: '"Space Mono", monospace',
                                        fontWeight: 400,
                                        fontSize: { xs: '10px', md: '15px' },
                                        lineHeight: 1,
                                        letterSpacing: '-0.8px',
                                        textTransform: 'uppercase',
                                        whiteSpace: 'nowrap',
                                        color: 'black',
                                    }}
                                >
                                    {tab.label}
                                </Box>
                            </Box>
                        </Button>
                    );
                })}
            </Box>

            <Box
                sx={{
                    maxWidth: { xs: '343px', md: '772px', lg: '1100px' },
                    mx: 'auto',
                    borderRadius: { xs: '16px', md: '20px' },
                    border: '1px solid rgba(0,0,0,0.06)',
                    overflow: 'hidden',
                    backgroundColor: 'white',
                    boxShadow: '0px 10px 30px rgba(0,0,0,0.06)',
                    display: { xs: 'flex', md: 'grid' },
                    flexDirection: { xs: 'column', md: 'unset' },
                    gridTemplateColumns: { md: 'minmax(0, 1fr) 360px', lg: 'minmax(0, 1fr) 380px' },
                }}
            >
                {/* Visual */}
                <Box
                    sx={{
                        backgroundColor: '#F6F5F4',
                        padding: { xs: 2, md: 3 },
                        borderBottom: { xs: '1px solid rgba(0,0,0,0.06)', md: 'none' },
                        borderRight: { xs: 'none', md: '1px solid rgba(0,0,0,0.06)' },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            borderRadius: { xs: '14px', md: '16px' },
                            overflow: 'hidden',
                            border: '1px solid rgba(0,0,0,0.06)',
                            backgroundColor: 'white',
                            boxShadow: '0px 4px 44px rgba(0,0,0,0.03)',
                        }}
                    >
                        <Box
                            component="img"
                            src={activeTabConfig.screenshotSrc}
                            alt={`${activeTabConfig.label} screenshot`}
                            sx={{
                                display: 'block',
                                width: '100%',
                                height: { xs: '220px', sm: '280px', md: '420px', lg: '480px' },
                                objectFit: 'cover',
                                objectPosition: 'top',
                            }}
                        />
                    </Box>
                </Box>

                {/* Copy */}
                <Box
                    sx={{
                        padding: { xs: 3, md: 4 },
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: '"Inter", sans-serif',
                            fontSize: { xs: '18px', md: '20px' },
                            fontWeight: 600,
                            lineHeight: 1.25,
                            letterSpacing: '-0.4px',
                            color: 'black',
                        }}
                    >
                        {activeTabConfig.heading}
                    </Typography>
                    <Box
                        component="ul"
                        sx={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                        }}
                    >
                        {activeTabConfig.bullets.map((bullet) => (
                            <Box
                                component="li"
                                key={bullet}
                                sx={{
                                    display: 'flex',
                                    gap: '10px',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <Box
                                    sx={{
                                        width: '5px',
                                        height: '5px',
                                        borderRadius: '999px',
                                        backgroundColor: 'rgba(0,0,0,0.35)',
                                        mt: '10px',
                                        flex: '0 0 auto',
                                    }}
                                />
                                <Typography
                                    sx={{
                                        fontFamily: '"Inter", sans-serif',
                                        fontSize: { xs: '15px', md: '16px' },
                                        fontWeight: 400,
                                        lineHeight: 1.6,
                                        letterSpacing: '-0.2px',
                                        color: 'black',
                                        opacity: 0.75,
                                    }}
                                >
                                    {bullet}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

const PricingCheckIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 23C5.92433 23 1 18.0757 1 12C1 5.92433 5.92433 1 12 1C18.0757 1 23 5.92433 23 12C23 18.0757 18.0757 23 12 23Z"
            fill="#57BE84"
        />
        <path d="M16 10L11 15L8 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const PricingFeatureLine = ({text}: {text: string}) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
        <Box sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto' }}>
            <PricingCheckIcon />
        </Box>
        <Typography
            sx={{
                fontFamily: '"Inter", sans-serif',
                fontSize: { xs: '14px', md: '16px' },
                lineHeight: { xs: '20px', md: '24px' },
                letterSpacing: '-0.5px',
                color: 'black',
                opacity: 0.7,
            }}
        >
            {text}
        </Typography>
    </Box>
);

const PricingSection = ({handleSignupFormOpen}: {handleSignupFormOpen: (opts?: any) => void}) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ textAlign: 'center', mb: { xs: '20px', md: '44px' } }}>
                <Typography
                    sx={{
                        fontFamily: '"Hedvig Letters Serif", serif',
                        fontSize: { xs: '32px', md: '60px' },
                        lineHeight: { xs: '34px', md: '67px' },
                        letterSpacing: { xs: '-1.5px', md: '-2.5px' },
                        color: 'black',
                        mb: { xs: 2, md: 2.5 },
                        maxWidth: { xs: '327px', md: 'none' },
                        mx: 'auto',
                    }}
                >
                    Pricing
                </Typography>
                <Typography
                    sx={{
                        fontFamily: '"Inter", sans-serif',
                        fontWeight: 500,
                        fontSize: { xs: '16px', md: '18px' },
                        lineHeight: { xs: '22px', md: '27px' },
                        letterSpacing: '-0.5px',
                        color: 'black',
                        opacity: 0.7,
                        maxWidth: { xs: '327px', md: '502px' },
                        mx: 'auto',
                    }}
                >
                    One plan. Everything you need.
                </Typography>
            </Box>

            <Box sx={{ maxWidth: { xs: '343px', md: '420px' }, mx: 'auto' }}>
                <Box
                    sx={{
                        width: '100%',
                        backgroundColor: '#F6F5F4',
                        borderRadius: '28px',
                        border: '1px solid rgba(0,0,0,0.03)',
                        overflow: 'hidden',
                        padding: '4px',
                    }}
                >
                    {/* Top (white) */}
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            borderTopLeftRadius: '24px',
                            borderTopRightRadius: '24px',
                            borderBottomLeftRadius: '8px',
                            borderBottomRightRadius: '8px',
                            paddingTop: '20px',
                            paddingX: '24px',
                            paddingBottom: '18px',
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: '"Space Mono", monospace',
                                fontWeight: 700,
                                fontSize: '15px',
                                lineHeight: '24px',
                                letterSpacing: '-0.8px',
                                textTransform: 'uppercase',
                                color: 'black',
                            }}
                        >
                            Studio
                        </Typography>
                        <Typography
                            sx={{
                                mt: 1.5,
                                fontFamily: '"Inter", sans-serif',
                                fontSize: { xs: '16px', md: '18px' },
                                lineHeight: { xs: '22px', md: '26px' },
                                letterSpacing: '-0.5px',
                                color: 'black',
                                opacity: 0.7,
                                px: 1,
                            }}
                        >
                            A complete workspace for your content.
                        </Typography>

                        <Box sx={{ mt: 3, display: 'flex', alignItems: 'baseline', justifyContent: 'center', gap: '6px' }}>
                            <Typography
                                sx={{
                                    fontFamily: '"Hedvig Letters Serif", serif',
                                    fontSize: '52px',
                                    lineHeight: '52px',
                                    letterSpacing: '-2.5px',
                                    color: 'black',
                                }}
                            >
                                $24
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: '"Hedvig Letters Serif", serif',
                                    fontSize: '32px',
                                    lineHeight: '32px',
                                    letterSpacing: '-2.5px',
                                    color: 'black',
                                }}
                            >
                                /mo
                            </Typography>
                        </Box>

                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
                            <Button
                                variant="contained"
                                onClick={(e) => {
                                    handleSignupFormOpen(e);
                                    trackLandingEvent("landing_cta_click_pricing_get_started");
                                }}
                                sx={{
                                    width: '277px',
                                    height: '36px',
                                    backgroundColor: 'black',
                                    color: 'white',
                                    borderRadius: '999px',
                                    textTransform: 'uppercase',
                                    fontFamily: '"Space Mono", monospace',
                                    fontWeight: 700,
                                    fontSize: '15px',
                                    lineHeight: '24px',
                                    letterSpacing: '-0.8px',
                                    boxShadow: '0px 1px 4px rgba(0,0,0,0.25)',
                                    '&:hover': {
                                        backgroundColor: '#111',
                                    },
                                }}
                            >
                                Get Started
                            </Button>
                        </Box>

                        <Typography
                            sx={{
                                mt: 1.5,
                                fontFamily: '"Inter", sans-serif',
                                fontSize: '13px',
                                lineHeight: '18px',
                                letterSpacing: '-0.2px',
                                color: 'black',
                                opacity: 0.7,
                            }}
                        >
                            Free 7-day trial · No credit card required
                        </Typography>
                    </Box>

                    {/* Features */}
                    <Box sx={{ paddingX: '20px', paddingTop: '18px', paddingBottom: '20px', display: 'flex', flexDirection: 'column', gap: '18px' }}>
                        <PricingFeatureLine text="Unlimited solo, screen, and remote recording" />
                        <PricingFeatureLine text="Transcript-based and timeline editing" />
                        <PricingFeatureLine text="Layouts, scenes, transitions and animation" />
                        <PricingFeatureLine text="Auto remove filler-words and word-gaps" />
                        {/*<PricingFeatureLine text="Export locally or publish to share page" />*/}
                        {/*<PricingFeatureLine text="Collaborative workspaces with sharing, comments, and editor & viewer roles" />*/}
                        <PricingFeatureLine text="Includes 20 hours of transcription and audio enhancement per month" />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

const FaqChevronIcon = ({open}: {open: boolean}) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        style={{
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 200ms ease',
            display: 'block',
        }}
    >
        <path d="M5 8L10 13L15 8" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const FAQ_ITEMS: Array<{question: string; answer: string}> = [
    {
        question: "What are the monthly limits on recording and editing?",
        answer: "You can record and edit as much as you like — there are no limits on recording, projects, or exports. The only monthly usage limit applies to transcription and audio enhancement (which uses Auphonic), which are included up to a generous monthly amount.",
    },
    {
        question: "How does recording work in the browser?",
        answer: "Libretto records audio and video locally in your browser for high quality, even on unreliable connections. Files upload in the background with automatic recovery and backups, so interruptions or network issues won’t cause you to lose a recording.",
    },
    {
        question: "Do I need to install anything to use Libretto?",
        answer: "No. Libretto works entirely in the browser. There’s nothing to download or install. You can record, invite guests, edit, and publish from your browser with just a link.",
    },
    {
        question: "Do I need to enter a credit card to try Libretto?",
        answer: "No. You can start a free 7-day trial without entering a credit card. You’ll have full access during the trial, and you can decide whether to continue only if Libretto fits your workflow.",
    },
    {
        question: "Can I cancel at any time or delete my account?",
        answer: "Yes. You can cancel your subscription at any time, and you can delete your account whenever you choose. When you do, your data is removed. Libretto never shares or repurposes your content.",
    },
];

const FAQSection = () => {
    const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ textAlign: 'center', mb: { xs: '24px', md: '64px' } }}>
                <Typography
                    sx={{
                        fontFamily: '"Hedvig Letters Serif", serif',
                        fontSize: { xs: '32px', md: '60px' },
                        lineHeight: { xs: '34px', md: '67px' },
                        letterSpacing: { xs: '-1.5px', md: '-2.5px' },
                        color: 'black',
                        mb: { xs: 2, md: 2.5 },
                        maxWidth: { xs: '327px', md: 'none' },
                        mx: 'auto',
                    }}
                >
                    Frequently asked questions
                </Typography>
            </Box>

            <Box sx={{ maxWidth: { xs: '343px', md: '712px', lg: '822px' }, mx: 'auto' }}>
                {FAQ_ITEMS.map((faq, i) => {
                    const isOpen = openFaqIndex === i;
                    const isLast = i === FAQ_ITEMS.length - 1;
                    const nextIsOpen = openFaqIndex === i + 1;

                    return (
                        <Box
                            key={i}
                            sx={{
                                py: '4px',
                                borderBottom: !isOpen && !isLast && !nextIsOpen ? '1px solid #E8DDD4' : '1px solid transparent',
                            }}
                        >
                            <Box
                                sx={{
                                    backgroundColor: isOpen ? '#F6F5F4' : 'transparent',
                                    borderRadius: isOpen ? { xs: '20px', md: '28px' } : 0,
                                    border: isOpen ? '1px solid rgba(0,0,0,0.03)' : '1px solid transparent',
                                    px: { xs: '16px', md: '24px' },
                                    py: { xs: '12px', md: '16px' },
                                    transition: 'background-color 200ms ease, border-color 200ms ease',
                                }}
                            >
                                <Box
                                    component="button"
                                    type="button"
                                    onClick={() => {
                                        const nextOpenIndex = isOpen ? null : i;
                                        setOpenFaqIndex(nextOpenIndex);
                                        if (nextOpenIndex === i) trackLandingEvent(`landing_faq_open_${i}`);
                                    }}
                                    aria-expanded={isOpen}
                                    aria-controls={`faq-panel-${i}`}
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        textAlign: 'left',
                                        backgroundColor: 'transparent',
                                        border: 0,
                                        padding: 0,
                                        cursor: 'pointer',
                                        '&:focus-visible': {
                                            outline: '2px solid rgba(0,0,0,0.3)',
                                            outlineOffset: '4px',
                                            borderRadius: '8px',
                                        },
                                    }}
                                >
                                    <Typography
                                        component="h3"
                                        sx={{
                                            fontFamily: '"Inter", sans-serif',
                                            fontWeight: 400,
                                            fontSize: { xs: '16px', md: '20px' },
                                            lineHeight: { xs: '22px', md: '28px' },
                                            letterSpacing: '-0.5px',
                                            color: 'black',
                                        }}
                                    >
                                        {faq.question}
                                    </Typography>

                                    <Box
                                        sx={{
                                            width: { xs: '32px', md: '36px' },
                                            height: { xs: '32px', md: '36px' },
                                            backgroundColor: 'white',
                                            border: '1px solid rgba(0,0,0,0.07)',
                                            borderRadius: '999px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flex: '0 0 auto',
                                            ml: { xs: '12px', md: '16px' },
                                        }}
                                    >
                                        <FaqChevronIcon open={isOpen} />
                                    </Box>
                                </Box>

                                {isOpen && (
                                    <Typography
                                        id={`faq-panel-${i}`}
                                        sx={{
                                            mt: { xs: 1.5, md: 2 },
                                            fontFamily: '"Inter", sans-serif',
                                            fontSize: { xs: '13px', md: '18px' },
                                            lineHeight: { xs: '18px', md: '27px' },
                                            letterSpacing: '-0.5px',
                                            color: 'black',
                                            opacity: 0.7,
                                            pr: { xs: '48px', md: '56px' },
                                        }}
                                    >
                                        {faq.answer}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

// Section 2: Quiet reassurance
const ReassuranceSection = ({authContext}) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            pt: { xs: 6, md: 10 },
            pb: { xs: 8, md: 12 },
            px: { xs: 3, md: 4 },
            maxWidth: 600,
            mx: 'auto',
        }}
    >
        <Typography
            sx={{
                fontFamily: '"Hedvig Letters Serif", serif',
                fontSize: { xs: '28px', sm: '36px' },
                lineHeight: { xs: '36px', sm: '44px' },
                letterSpacing: '-1px',
                color: 'black',
                mb: 2,
            }}
        >
            From first take to finished content
        </Typography>
        <Typography
            sx={{
                fontFamily: '"Inter", sans-serif',
                fontSize: { xs: '15px', sm: '17px' },
                lineHeight: { xs: '24px', sm: '28px' },
                letterSpacing: '-0.3px',
                color: 'black',
                opacity: 0.6,
            }}
        >
            Everything you need to create, edit, and publish.
        </Typography>
        <Button
            variant="contained"
            sx={{
                backgroundColor: 'black',
                color: 'white',
                height: '36px',
                borderRadius: '10px',
                padding: '13px 14px',
                textTransform: 'uppercase',
                fontFamily: '"Space Mono", monospace',
                fontWeight: 700,
                fontSize: '15px',
                minWidth: "150px",
                lineHeight: '24px',
                letterSpacing: '-0.8px',
                boxShadow: '0px 1px 4px 0px rgba(0,0,0,0.25)',
                whiteSpace: 'nowrap',
                marginTop: "12px",
                zIndex: 1,
                '&:hover': {
                    backgroundColor: '#333',
                },
            }}
            onClick={(e) => {
                authContext.handleSignupFormOpen(e);
                trackLandingEvent("landing_cta_click_reassurance_get_started");
            }}
        >
            Get Started
        </Button>
    </Box>
);

const FooterLink = ({label, href, onClick}: {label: string; href?: string; onClick?: () => void}) => {
    return (
        <Button
            component={href ? "a" : "button"}
            href={href}
            onClick={onClick}
            variant="text"
            disableRipple
            sx={{
                minWidth: 'auto',
                padding: 0,
                textTransform: 'none',
                fontFamily: '"Inter", sans-serif',
                fontSize: { xs: '13px', md: '15px', lg: '16px' },
                lineHeight: { xs: '22px', md: '24px', lg: '26px' },
                letterSpacing: '-0.5px',
                color: 'black',
                opacity: 0.7,
                '&:hover': {
                    backgroundColor: 'transparent',
                    opacity: 1,
                },
            }}
        >
            {label}
        </Button>
    );
};

const LandingFooter = () => {
    const navigate = useNavigate();

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#F6F5F4',
                width: '100%',
                pt: { xs: '24px', md: '48px' },
                pb: { xs: '24px', md: '40px' },
            }}
        >
            <Box
                sx={{
                    maxWidth: 1440,
                    mx: 'auto',
                    px: { xs: 2, md: 3.5 },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: { xs: 'center', md: 'flex-start' },
                        justifyContent: 'space-between',
                        gap: { xs: 3, md: 6 },
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: { xs: 'center', md: 'flex-start' },
                            textAlign: { xs: 'center', md: 'left' },
                            gap: { xs: 1.5, md: 2 },
                        }}
                    >
                        <Box sx={{ display: 'flex' }}>
                            <NewLogoIconWithText />
                        </Box>
                        <Typography
                            sx={{
                                fontFamily: '"Inter", sans-serif',
                                fontSize: { xs: '15px', md: '16px', lg: '18px' },
                                lineHeight: { xs: '24px', md: '24px', lg: '26px' },
                                letterSpacing: '-0.5px',
                                color: 'black',
                                opacity: 0.7,
                                maxWidth: { xs: '327px', md: '380px', lg: '520px' },
                            }}
                        >
                            Recording and editing for spoken-word content.
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: { xs: 'center', md: 'flex-end' },
                            flexWrap: { xs: 'wrap', md: 'wrap', lg: 'nowrap' },
                            gap: { xs: '16px', md: '20px', lg: '28px' },
                        }}
                    >
                        <FooterLink label="Pricing" href="#pricing" />
                        <FooterLink label="FAQ" href="#faq" />
                        <FooterLink label="Contact" href="mailto:contact@libretto.fm" />
                        <FooterLink label="Terms" onClick={() => navigate('/terms')} />
                        <FooterLink label="Privacy" onClick={() => navigate('/privacy')} />
                    </Box>
                </Box>

                <Box
                    sx={{
                        mt: { xs: 3, md: 4 },
                        pt: { xs: 3, md: 3.5 },
                        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
                        display: 'flex',
                        justifyContent: { xs: 'center', md: 'flex-start' },
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: '"Inter", sans-serif',
                            fontSize: { xs: '12px', md: '15px', lg: '16px' },
                            lineHeight: { xs: '18px', md: '24px', lg: '26px' },
                            letterSpacing: '-0.5px',
                            color: 'black',
                            opacity: 0.6,
                            textAlign: { xs: 'center', md: 'left' },
                        }}
                    >
                        © 2026 Libretto. All rights reserved.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

const V2InitialLandingPage = () => {
    const isMobile = useMediaQuery("(max-width:1150px)");
    const authContext = useContext(AuthContext);

    // Set page title for landing page
    useEffect(() => {
        document.title = "Libretto | A better way to record and edit.";
        trackLandingEvent("landing_view");
    }, []);

    const pageStyle = {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
    };

    const closeSignupOpenLogin = () => {
        authContext.handleSignupFormClose();
        authContext.handleLoginFormOpen();
    };

    return (
        <Box sx={pageStyle}>
            {/* HEADER + MODALS + HERO live inside the flex-growing middle */}
            <Box
                sx={{
                    flexGrow: 1,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        width: "100%",
                        maxWidth: 1450,
                        padding: "20px",
                        position: "relative",
                    }}
                >
                    <Box
                        sx={{ display: "flex", cursor: "pointer" }}
                        onClick={() => {}}
                    >
                        <NewLogoIconWithText />
                    </Box>

                    {!isMobile && (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: { md: "24px", lg: "32px" },
                                position: "absolute",
                                left: "50%",
                                transform: "translateX(-50%)",
                            }}
                        >
                            {/* <V2TopBarNavLink label="Features" href="#features" /> */}
                            <V2TopBarNavLink label="How it Works" href="#how-it-works" />
                            <V2TopBarNavLink label="Pricing" href="#pricing" />
                            <V2TopBarNavLink label="FAQ" href="#faq" />
                        </Box>
                    )}

                    <Box sx={{ display: "flex", alignItems: "center", gap: "12px", marginLeft: "auto" }}>
                        <V2SigninButton
                            onClick={() => {
                                authContext.handleLoginFormOpen();
                                trackLandingEvent("landing_cta_click_topbar_sign_in");
                            }}
                        />
                        <V2GetStartedButton
                            onClick={(e) => {
                                authContext.handleSignupFormOpen(e);
                                trackLandingEvent("landing_cta_click_topbar_get_started");
                            }}
                        />
                    </Box>

                    {/* Login dialog */}
                    <Dialog
                        open={authContext.loginFormOpen}
                        onClose={authContext.handleLoginFormClose}
                        aria-labelledby="form-dialog-title"
                        sx={{
                            "& .MuiDialog-paper": {
                                borderRadius: "20px",
                            },
                        }}
                    >
                        <DialogContent
                            sx={{
                                borderRadius: "30px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minWidth: { xs: "300px", md: "400px" },
                            }}
                        >
                            <V2LoginForm
                                signinWithGoogle={authContext.signinWithGoogle}
                                handleLoginFormClose={authContext.handleLoginFormClose}
                                signinWithEmail={authContext.signinWithEmail}
                                handleSignUpFormOpen={authContext.handleSignupFormOpen}
                                sendPasswordResetEmailForUser={
                                    authContext.sendPasswordResetEmailForUser
                                }
                            />
                        </DialogContent>
                    </Dialog>

                    {/* Signup message dialog */}
                    <Dialog
                        open={authContext.signUpStateMessageOpen}
                        onClose={authContext.handleSignupStateMessageClose}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogContent
                            sx={{
                                borderRadius: "30px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: { xs: "300px", md: "400px" },
                            }}
                        >
                            <V2SignupMessage
                                signUpStateMessage={authContext.signUpStateMessage}
                            />
                        </DialogContent>
                    </Dialog>

                    {/* Signup dialog */}
                    <Dialog
                        open={authContext.signupFormOpen}
                        onClose={authContext.handleSignupFormClose}
                        aria-labelledby="form-dialog-title"
                        sx={{
                            "& .MuiDialog-paper": {
                                borderRadius: "20px",
                            },
                        }}
                    >
                        <DialogContent
                            sx={{
                                borderRadius: "30px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minWidth: { xs: "300px", md: "400px" },
                            }}
                        >
                            <V2SignupForm
                                selectedPricingOption={"Annual"}
                                signupWithGoogle={authContext.signupWithGoogle}
                                closeSignupOpenLogin={closeSignupOpenLogin}
                                signUpWithEmailAndPassword={
                                    authContext.signUpWithEmailAndPassword
                                }
                            />
                        </DialogContent>
                    </Dialog>
                </Box>

                {/* Hero section */}
                <Box
                    sx={{
                        width: "100%",
                        maxWidth: 1600,
                        px: { xs: 2, md: 3 },
                        pt: { xs: 4, md: 6 },
                        pb: { xs: 0, md: 1 }, // Minimal bottom padding
                    }}
                >
                    <HeroSection
                        isMobile={isMobile}
                        handleLoginFormOpen={authContext.handleLoginFormOpen}
                        handleSignupFormOpen={authContext.handleSignupFormOpen}
                    />
                </Box>

                {/* Section 1: How Libretto works */}
                <Box
                    component="section"
                    id="how-it-works"
                    sx={{
                        width: "100%",
                        mt: { xs: '-24px', md: '-32px' },
                        pt: { xs: '64px', md: '96px' },
                        pb: { xs: '40px', md: '80px' },
                        backgroundColor: '#FAFAFA',
                        borderTopLeftRadius: { xs: '48px', md: '72px' },
                        borderTopRightRadius: { xs: '48px', md: '72px' },
                        borderBottomLeftRadius: { xs: '48px', md: '72px' },
                        borderBottomRightRadius: { xs: '48px', md: '72px' },
                        borderTop: '1px solid rgba(0,0,0,0.04)',
                        overflow: 'hidden',
                        scrollMarginTop: '90px',
                    }}
                >
                    <Box
                        sx={{
                            maxWidth: 1440,
                            mx: 'auto',
                            px: { xs: 2, md: 3.5 },
                        }}
                    >
                        <HowItWorksSection />
                    </Box>
                </Box>

                {/* Section 2: Features (temporarily hidden) */}
                {/*
                    <Box
                        component="section"
                        id="features"
                        sx={{
                            width: "100%",
                            py: { xs: '40px', md: '80px' },
                            scrollMarginTop: '90px',
                            backgroundColor: 'white',
                        }}
                    >
                        <Box
                            sx={{
                                maxWidth: 1440,
                                mx: 'auto',
                                mt: { xs: '20px', md: '36px' },
                                px: { xs: 2, md: 3.5 },
                            }}
                        >
                            <FeaturesSection />
                        </Box>
                    </Box>
                */}

                {/* Section 3: Pricing */}
                <Box
                    component="section"
                    id="pricing"
                    sx={{
                        width: "100%",
                        py: { xs: '40px', md: '80px' },
                        scrollMarginTop: '90px',
                        backgroundColor: '#FAFAFA',
                        borderTopLeftRadius: { xs: '48px', md: '72px' },
                        borderTopRightRadius: { xs: '48px', md: '72px' },
                        borderBottomLeftRadius: { xs: '48px', md: '72px' },
                        borderBottomRightRadius: { xs: '48px', md: '72px' },
                        borderTop: '1px solid rgba(0,0,0,0.04)',
                        overflow: 'hidden',
                    }}
                >
                    <Box
                        sx={{
                            maxWidth: 1440,
                            mx: 'auto',
                            px: { xs: 2, md: 3.5 },
                        }}
                    >
                        <PricingSection handleSignupFormOpen={authContext.handleSignupFormOpen} />
                    </Box>
                </Box>

                {/* Section 4: FAQ */}
                <Box
                    component="section"
                    id="faq"
                    sx={{
                        width: "100%",
                        pt: { xs: '40px', md: '80px' },
                        pb: { xs: '24px', md: '48px' },
                        scrollMarginTop: '90px',
                        backgroundColor: 'white',
                    }}
                >
                    <Box
                        sx={{
                            maxWidth: 1440,
                            mx: 'auto',
                            px: { xs: 2, md: 3.5 },
                        }}
                    >
                        <FAQSection />
                    </Box>
                </Box>

                {/* Section 4: Reassurance */}
                <Box
                    sx={{
                        width: "100%",
                    }}
                >
                    <ReassuranceSection authContext={authContext} />
                </Box>
            </Box>

            {/* FOOTER */}
            <Box
                sx={{
                    width: "100%",
                }}
            >
                <LandingFooter />
            </Box>
        </Box>
    );
};

export default V2InitialLandingPage;
